module.exports = __webpack_public_path__ + "img/80.3623aa9e.jpg";